/* ==========================================================================
   UGC Pagination
   ========================================================================== */

function ugcPaginate(button, direction) {
  var nav = button.closest('.product-ugc__pagination');
  var perPage = parseInt(nav.dataset.perPage, 10);
  var total = parseInt(nav.dataset.total, 10);
  var totalPages = Math.ceil(total / perPage);
  var currentPageEl = nav.querySelector('[data-current-page]');
  var currentPage = parseInt(currentPageEl.textContent, 10);

  currentPage += direction;
  if (currentPage < 1) currentPage = 1;
  if (currentPage > totalPages) currentPage = totalPages;

  currentPageEl.textContent = currentPage;

  var grid = nav.closest('.product-ugc').querySelector('.product-ugc__grid');
  var items = grid.querySelectorAll('.product-ugc__item');
  var start = (currentPage - 1) * perPage;
  var end = start + perPage;

  items.forEach(function (item, index) {
    item.hidden = index < start || index >= end;
  });

  nav.querySelector('[data-direction="prev"]').disabled = currentPage <= 1;
  nav.querySelector('[data-direction="next"]').disabled = currentPage >= totalPages;

  /* スクロール：セクション上部に戻す */
  var section = nav.closest('.product-ugc');
  if (section) {
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/* ==========================================================================
   UGC Vote — 共有カウント（Google Apps Script）+ localStorage フォールバック
   ========================================================================== */

function ugcGetApiUrl() {
  var el = document.querySelector('.product-ugc');
  return el ? el.dataset.voteApiUrl : '';
}

function ugcVote(button) {
  var id = button.dataset.ugcId;
  var key = 'ugc_vote_' + id;
  var countEl = button.querySelector('.product-ugc__vote-count');
  var isVoted = localStorage.getItem(key) === '1';
  var action = isVoted ? 'unvote' : 'vote';

  /* Optimistic UI update */
  if (isVoted) {
    localStorage.removeItem(key);
    button.classList.remove('is-voted');
    countEl.textContent = Math.max(0, parseInt(countEl.textContent, 10) - 1);
  } else {
    localStorage.setItem(key, '1');
    button.classList.add('is-voted');
    countEl.textContent = parseInt(countEl.textContent, 10) + 1;
  }

  /* API 呼び出し（設定されている場合） */
  var apiUrl = ugcGetApiUrl();
  if (apiUrl) {
    fetch(apiUrl + '?action=' + action + '&ugc_id=' + encodeURIComponent(id), {
      redirect: 'follow'
    })
      .then(function (r) { return r.json(); })
      .then(function (counts) {
        /* サーバーの正確なカウントで上書き */
        if (counts[id] !== undefined) {
          countEl.textContent = counts[id];
        }
      })
      .catch(function () { /* ネットワークエラー時は optimistic 値を維持 */ });
  }
}

/* ページ読み込み時に共有カウントを取得 → 投票済み状態を復元 → デフォルトソート(Vote順) */
document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll('.product-ugc__vote');
  if (!buttons.length) return;

  var apiUrl = ugcGetApiUrl();

  if (apiUrl) {
    fetch(apiUrl + '?action=counts', { redirect: 'follow' })
      .then(function (r) { return r.json(); })
      .then(function (counts) {
        buttons.forEach(function (button) {
          var id = button.dataset.ugcId;
          var countEl = button.querySelector('.product-ugc__vote-count');
          if (counts[id] !== undefined) countEl.textContent = counts[id];
          if (localStorage.getItem('ugc_vote_' + id) === '1') {
            button.classList.add('is-voted');
          }
        });
        ugcSort('votes');
      })
      .catch(function () {
        ugcRestoreLocal(buttons);
        ugcSort('votes');
      });
  } else {
    ugcRestoreLocal(buttons);
    ugcSort('votes');
  }
});

function ugcRestoreLocal(buttons) {
  buttons.forEach(function (button) {
    var id = button.dataset.ugcId;
    if (localStorage.getItem('ugc_vote_' + id) === '1') {
      button.classList.add('is-voted');
      var countEl = button.querySelector('.product-ugc__vote-count');
      countEl.textContent = parseInt(countEl.textContent, 10) + 1;
    }
  });
}

/* ==========================================================================
   UGC Sort
   ========================================================================== */

function ugcSort(mode) {
  var grid = document.querySelector('.product-ugc__grid');
  if (!grid) return;

  var items = Array.from(grid.querySelectorAll('.product-ugc__item'));
  if (items.length < 2) return;

  items.sort(function (a, b) {
    if (mode === 'votes') {
      var aV = parseInt(a.querySelector('.product-ugc__vote-count').textContent, 10) || 0;
      var bV = parseInt(b.querySelector('.product-ugc__vote-count').textContent, 10) || 0;
      return bV - aV;
    }
    var aO = parseInt(a.dataset.order, 10) || 0;
    var bO = parseInt(b.dataset.order, 10) || 0;
    return mode === 'newest' ? bO - aO : aO - bO;
  });

  items.forEach(function (item) { grid.appendChild(item); });

  /* active ボタンを更新 */
  document.querySelectorAll('.product-ugc__sort-btn').forEach(function (btn) {
    btn.classList.toggle('is-active', btn.dataset.sort === mode);
  });

  /* ページネーションをリセット */
  ugcResetPagination();
}

function ugcResetPagination() {
  var grid = document.querySelector('.product-ugc__grid');
  if (!grid) return;

  var items = grid.querySelectorAll('.product-ugc__item');
  items.forEach(function (item, i) { item.hidden = i >= 6; });

  var nav = document.querySelector('.product-ugc__pagination');
  if (!nav) return;

  var pageEl = nav.querySelector('[data-current-page]');
  if (pageEl) pageEl.textContent = '1';

  var prev = nav.querySelector('[data-direction="prev"]');
  var next = nav.querySelector('[data-direction="next"]');
  if (prev) prev.disabled = true;
  if (next) next.disabled = items.length <= 6;
}

/* ==========================================================================
   UGC Form
   ========================================================================== */

function handleUgcButtonClick(button) {
  const hasPurchased = button.getAttribute('data-has-purchased') === 'true';
  const section = button.closest('.product-ugc');

  if (hasPurchased) {
    /* セクション内の最新版を優先（エディタ再描画対応） */
    var modal = section.querySelector('.product-ugc__form-modal');
    if (modal) {
      /* body に残った旧モーダルを除去 */
      document.querySelectorAll('body > .product-ugc__form-modal').forEach(function (old) {
        old.remove();
      });
      document.body.appendChild(modal);
    } else {
      modal = document.body.querySelector(':scope > .product-ugc__form-modal');
    }
    if (!modal) return;
    modal.style.display = 'flex';
  } else {
    var prompt = section.querySelector('.product-ugc__purchase-prompt');
    if (prompt) {
      document.querySelectorAll('body > .product-ugc__purchase-prompt').forEach(function (old) {
        old.remove();
      });
      document.body.appendChild(prompt);
    } else {
      prompt = document.body.querySelector(':scope > .product-ugc__purchase-prompt');
    }
    if (!prompt) return;
    prompt.style.display = 'flex';
  }
}

function closeUgcModal() {
  document.querySelectorAll('.product-ugc__form-modal').forEach(function (modal) {
    modal.style.display = 'none';
  });
}

function submitUgcForm(event) {
  event.preventDefault();

  const form = event.target;
  /* モーダルが body に移動済みなので、元のセクションから URL を取得 */
  const sectionEl = document.querySelector('.product-ugc[data-google-form-url]');
  const googleFormUrl = sectionEl ? sectionEl.getAttribute('data-google-form-url') : null;

  if (!googleFormUrl) {
    alert('送信先が設定されていません。管理者にお問い合わせください。');
    return false;
  }

  const formData = new FormData(form);
  const submitButton = form.querySelector('.ugc-form__submit');
  submitButton.disabled = true;
  submitButton.textContent = '送信中...';

  fetch(googleFormUrl, {
    method: 'POST',
    mode: 'no-cors',
    body: formData,
  })
    .then(function () {
      form.style.display = 'none';
      var success = form.closest('.ugc-form__dialog').querySelector('.ugc-form__success');
      success.style.display = 'block';
    })
    .catch(function () {
      alert('送信に失敗しました。もう一度お試しください。');
      submitButton.disabled = false;
      submitButton.textContent = '送信する';
    });

  return false;
}

